import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { IconMenu, IconX } from './Icons';
import styles from './Navbar.module.css';

export default function Navbar({ onNavigate }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id) => {
    setMobileOpen(false);
    if (location.pathname !== '/') {
      navigate('/', { state: { scrollTo: id } });
    } else {
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 50);
    }
  };

  const goTo = (path) => {
    setMobileOpen(false);
    navigate(path);
  };

  // [label, action-type, value]
  // type: 'scroll' | 'page'
  const navItems = [
    { label: 'About Us',         type: 'scroll', value: 'about' },
    { label: 'This Week Trips',  type: 'scroll', value: 'trips' },
    { label: 'Corporate',        type: 'page',   value: '/corporate' },
    { label: 'All Trips',        type: 'page',   value: '/trips' },
    { label: 'Blog',             type: 'page',   value: '/blog' },
    { label: 'Experiences',     type: 'page',   value: '/experiences' },
  ];

  const handleNav = (item) => {
    if (item.type === 'scroll') scrollTo(item.value);
    else goTo(item.value);
  };

  return (
    <>
      <nav className={`${styles.nav} ${scrolled ? styles.scrolled : ''}`}>
        <div className={styles.logo} onClick={() => navigate('/')}>
          <div className={styles.logoTextGroup}>
            <span className={styles.logoText}>Keepers</span>
            <span className={styles.logoSub}>Experience</span>
          </div>
        </div>

        <div className={styles.links}>
          {navItems.map(item => (
            <button key={item.label} className={styles.link} onClick={() => handleNav(item)}>
              {item.label}
            </button>
          ))}
          <button className={styles.cta} onClick={() => scrollTo('contact')}>
            Contact Us
          </button>
        </div>

        <button className={styles.hamburger} onClick={() => setMobileOpen(true)}>
          <IconMenu />
        </button>
      </nav>

      {mobileOpen && (
        <div className={styles.mobileMenu}>
          <button className={styles.mobileClose} onClick={() => setMobileOpen(false)}>
            <IconX />
          </button>
          <div className={styles.mobileLogo}>
            <img src="/keepers-logo.png" alt="Keepers" className={styles.mobileLogoImg} />
          </div>
          {navItems.map((item, i) => (
            <button
              key={item.label}
              className={styles.mobileLink}
              style={{ animationDelay: `${i * 0.07}s` }}
              onClick={() => handleNav(item)}
            >
              {item.label}
            </button>
          ))}
          <button
            className={styles.mobileCta}
            style={{ animationDelay: `${navItems.length * 0.07}s` }}
            onClick={() => scrollTo('contact')}
          >
            Contact Us
          </button>
        </div>
      )}
    </>
  );
}
